/* eslint-disable */

import React from 'react';
import styles from './EngagementChart.module.css';
import {
	AreaChart,
	Area,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import { EngagementChartProps } from './types';

const EngagementChart: React.FC<EngagementChartProps> = ({
	title,
	subtitle,
	data,
	height,
	width = '100%',
	lineColor = '#147B58',
	gradientFrom = 'rgba(20, 123, 88, 0.5)',
	gradientTo = 'rgba(20, 123, 88, 0)',
	showGrid = true,
	showTooltip = true,
	xKey = 'name',
	yKey = 'value',
	className,
}) => {
	const gradientId = `gradient-${Math.random()}`;
	const isMobile = window.innerWidth <= 480;

	return (
		<div
			className={`${styles.container} ${className || ''}`}
			style={{ height: `${height}px` }} // ✅ TOTAL height
		>
			<div className={styles.header}>
				<div className={styles.title}>{title}</div>
				{subtitle && <div className={styles.subtitle}>{subtitle}</div>}
			</div>

			<div className={styles.chartWrapper}>
				<ResponsiveContainer width="100%" height="100%">
					<AreaChart
						data={data}
						margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
					>
						<defs>
							<linearGradient
								id={gradientId}
								x1="0"
								y1="0"
								x2="0"
								y2="1"
							>
								<stop
									offset="5%"
									stopColor={gradientFrom}
									stopOpacity={0.8}
								/>
								<stop
									offset="95%"
									stopColor={gradientTo}
									stopOpacity={0}
								/>
							</linearGradient>
						</defs>

						{showGrid && <CartesianGrid strokeDasharray="3 3" />}

						{/* <XAxis dataKey={xKey} /> */}
						<XAxis
							dataKey={xKey}
							interval={isMobile ? 'preserveStartEnd' : 0}
							tick={{ fontSize: isMobile ? 10 : 12 }}
						/>
						{/* <YAxis /> */}
						<YAxis
							width={isMobile ? 30 : 40}
							tick={{ fontSize: isMobile ? 10 : 12 }}
						/>

						{showTooltip && <Tooltip />}

						<Area
							type="monotone"
							dataKey={yKey}
							stroke={lineColor}
							fill={`url(#${gradientId})`}
							strokeWidth={2}
						/>
					</AreaChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
};

export default EngagementChart;
